export const mentionDisplayStyle = {
  width: '100%',
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 400,
  },

  '&multiLine': {
    control: {
      fontFamily: '"Lato",Arial,sans-serif',
      minHeight: 40,
      lineHeight: 1.5,
    },
    highlighter: {
      padding: 9,
      border: 'none',
    },
    input: {
      padding: 9,
      border: 'none',
      lineHeight: 'inherit',
    },
  },
};

export const mentionInputStyle = {
  width: '100%',
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
  },

  '&multiLine': {
    control: {
      fontFamily: '"Lato",Arial,sans-serif',
      minHeight: 60,
      wordBreak: 'break-word',
    },
    highlighter: {
      padding: 9,
      border: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42',
    },
    input: {
      padding: 9,
      border: 'none',
      outline: 'none',
      overflow: 'auto',
      resize: 'none',
      lineHeight: 'inherit',
      WebkitBoxShadow: 'none',
      MozBoxShadow: 'none',
      boxShadow: 'none',
    },
  },

  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 16,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#ADD8E6',
      },
    },
  },
};

export const mentionStyle = {
  backgroundColor: '#00A9E0',
  opacity: 0.3,
  padding: 1,
  marginLeft: -1,
  borderRadius: 3,
};

export const editedStyle = {
  fontStyle: 'italic',
  fontWeight: 700,
  fontSize: 12,
  marginLeft: 9,
  color: 'rgba(0,0,0,.50)',
};

export const mentionDisplayStylePop = {
  width: '100%',
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 400,
  },

  '&multiLine': {
    control: {
      fontFamily: '"Lato",Arial,sans-serif',
      minHeight: 40,
      lineHeight: 1.25,
    },
    highlighter: {
      padding: 1,
      border: 'none',
    },
    input: {
      padding: 1,
      border: 'none',
      lineHeight: 'inherit',
    },
  },
};
